import React from 'react';
import { ContentBlock, RawHtml } from '../../../common/index.jsx';
import PropTypes from 'prop-types';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import dayjs from 'dayjs';
import {
  DATETIME_FORMAT_DATETIME,
  formattedFullName,
  getFilenameFromPath,
} from '../../../../utils/helpers/CommonHelper.jsx';
import { EditOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { BackIcon } from '../../../../utils/helpers/UtilityComponents.jsx';
import { NewsSignature } from '../../../../utils/helpers/UtilityComponents.jsx';
import { useTranslation } from 'react-i18next';
import { DEFAULT_IMAGE } from '../../../../utils/constants/common_constants.js';
import HtmlContentWithAntdImages from '../../../common/Image/HtmlContentWithAntdImages.jsx';

const NewsDetail = ({
  newsDetail,
  isEnglishVersion,
  displayEnglishVersion,
  displayEditIcon,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const createdDate = dayjs(newsDetail.created_at || new Date()).format(
    DATETIME_FORMAT_DATETIME,
  );
  const alternateLanguageSlug = isEnglishVersion ? newsDetail.slug_sk : newsDetail.slug_en;
  const alternateLanguageHref = alternateLanguageSlug
    ? `${isEnglishVersion ? routes.newsDetail : routes.newsDetailEnglish}/${alternateLanguageSlug}`
    : null;
  const alternateLanguageLabel = isEnglishVersion
    ? t('SK')
    : t('EN');
  const alternateLanguageCode = isEnglishVersion ? 'sk' : 'en';

  return (
    <div className="news-detail-page-container add-icons-to-file-anchors">
      <ContentBlock
        contentVisible
        blockWrapper="block-wrapper"
        contentWrapper="content-wrapper"
        shadow
        title={
          displayEnglishVersion ? newsDetail.title_en : newsDetail.title_sk
        }
        actions={
          displayEditIcon
            ? [
                {
                  key: 'edit',
                  title: 'Upraviť',
                  onClick: () =>
                    navigate(`${routes.cmsNewsEdit}/${newsDetail.id}`, {
                      state: { from: location, fromDetail: true },
                    }),
                  icon: <EditOutlined />,
                },
              ]
            : []
        }
      >
        <div>
          {newsDetail.image_name && (
            <div
              className="foto-wrapper"
              style={{ float: 'left', marginRight: '7px' }}
            >
              <img
                src={'/storage/presentation_images/' + newsDetail?.image_name}
                alt={newsDetail.title}
                title={newsDetail.title}
                onError={({ currentTarget }) => {
                  if (currentTarget.src !== DEFAULT_IMAGE) {
                    // prevents looping
                    currentTarget.onerror = null;
                    currentTarget.src = DEFAULT_IMAGE;
                  }
                }}
              />
            </div>
          )}
          <HtmlContentWithAntdImages
            content={
              displayEnglishVersion
                ? newsDetail.content_en
                : newsDetail.content_sk
            }
          />
        </div>
        <NewsSignature
          nameOfCreator={formattedFullName(newsDetail.person)}
          dateOfCreation={createdDate}
        />
        {alternateLanguageHref && (
          <p style={{ marginTop: 2 , textAlign: 'right'  }}>
            <a
              href={alternateLanguageHref}
              onClick={async (event) => {
                event.preventDefault();
                await i18n.changeLanguage(alternateLanguageCode);
                navigate(alternateLanguageHref, {
                  state: { from: location },
                });
              }}
            >
              {alternateLanguageLabel}
            </a>
          </p>
        )}
      </ContentBlock>
    </div>
  );
};

NewsDetail.propTypes = {
  newsDetail: PropTypes.object,
  isEnglishVersion: PropTypes.bool,
  displayEnglishVersion: PropTypes.bool,
  displayEditIcon: PropTypes.bool,
  redirectToPage: PropTypes.func,
};

export default NewsDetail;
